import {
  VerificationApi,
  type GeneratePayload,
  type VerifyPayload,
} from '../api/VerificationApi';
import {type FetcherSettings} from '../api/apiClient';

class VerificationService {
  private readonly verificationApi: VerificationApi;

  constructor() {
    this.verificationApi = new VerificationApi();
  }

  generate(payload: GeneratePayload, resolverSettings?: FetcherSettings) {
    return this.verificationApi.generate(payload, resolverSettings);
  }

  verify(payload: VerifyPayload, resolverSettings?: FetcherSettings) {
    return this.verificationApi.verify(payload, resolverSettings);
  }

  getSettings(housingId: string, resolverSettings?: FetcherSettings) {
    return this.verificationApi.getSettings(housingId, resolverSettings);
  }
}

export {VerificationService};
